import { DEFAULT_THEME } from 'lib/partners/metadata';

export default {
    ...DEFAULT_THEME.colors,
};
